/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, debug) {
	'use strict';

	/**
	 * Device Switch
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class DeviceSwitch
	 * @extends Tc.Module
	 */
	Tc.Module.DeviceSwitch = Tc.Module.extend({

		config : {
			cookieName : 'pps',
			cookieValueMobile : 'mobile',
			cookieValueDesktop : 'desktop',
			days : 1
		},

		on: function(callback) {
			var mod = this,
				cookieName = mod.config.cookieName,
				days = mod.config.days,
				selectMobile = false;

			mod.$ctx.on('click', 'a', function (e) {
				e.preventDefault();

				selectMobile = $(this).hasClass('scs-dsm');

				var options = {
					path : '/',
					expiresAt : mod.setCookieExpiresInDays(days)
				};

				// Set cookie for 24 hrs
				if (selectMobile) {
					$.cookies.set(cookieName, mod.config.cookieValueMobile, options);
				} else {
					$.cookies.set(cookieName, mod.config.cookieValueDesktop, options);
				}
				debug.log('Tc.Module.DeviceSwitch > Switch to' + (selectMobile ? 'Mobile' : 'Desktop'));
				window.location.reload();
			});

			callback();
		},

		/**
		 * Creates new date object adding "days" to the current date and time
		 *
		 * @method setCookieExpiresInDays
		 * @param days
		 * @return {Date}
		 */
		setCookieExpiresInDays: function (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			return date;
		}

	});
}(window.Tc.$, window.Tc, window.debug));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.DeviceSwitch.js
// module id = 136
// module chunks = 0